import template from './commonicdchangesbydrg.html';
import controller from './commonicdchangesbydrg.controller';
import './commonicdchangesbydrg.styl';

let commonicdchangesbydrgComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default commonicdchangesbydrgComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchangesbydrg/commonicdchangesbydrg.component.js